<template lang="html">
  <div class="admin-edit-collection vh-100 w-full overflow-y-scroll pa4 row">
    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 pa0">
      <!-- Edit Category Description -->
      <div :key="collection.name" class="w-100 flex align-center">
        <span class="collection-name">{{ collection.name }}</span>
        <pl-button
          @click.native="editCategoryName()"
          class="pl-small pl-icon ml1"
        >
          <i class="fas fa-edit"></i>
        </pl-button>
      </div>

      <!-- See in Universe Link -->
      <a class="link w-100" @click="goToUniverse()"> See in Universe </a>

      <div class="ml1 pl-color-ruby" style="margin-left: 0; margin-top: 20px">
        (a position of 0 will exclude it from the universe home page)
      </div>
      <!-- Default Position -->
      <div class="mv4 default-position" style="margin-top=10px;">
        <span class="section-header mv0 mr2">Default Position: </span>
        <select v-model="collection.position">
          <option
            :value="position"
            :key="'pos' + position"
            v-for="position in nCategories"
          >
            {{ position }}
          </option>
        </select>
      </div>

      <!-- Description -->
      <div class="description">
        <span class="section-header">Description: </span>
        <textarea
          class="mt1"
          v-model="collection.description"
          style="width: 100%; height: 150px; resize: none"
        ></textarea>
      </div>

      <!-- Subject Areas -->
      <div class="mt4">
        <span class="section-header">Subject Areas:</span>
        <multiselect
          class="mt2"
          v-model="selectedSubjects"
          :options="subjects"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select subjects"
          label="name"
          track-by="id"
          :preselect-first="true"
        >
        </multiselect>
      </div>

      <!-- Grades -->
      <div class="mt4 dib">
        <span class="section-header">Grades:</span>
        <div class="grades">
          <div
            class="grade mt2"
            v-for="(grade, gradeIndex) in gradeLevels"
            :key="grade + gradeIndex"
          >
            <pl-checkbox v-model="selectedGradeLevels" :value="grade.id" />

            <span style="margin-left: 30px">{{ grade.grade }}</span>
          </div>
        </div>
      </div>

      <!-- Tags -->
      <div class="w-100 mt4">
        <span class="section-header">Tags:</span>
        <div class="mt2">
          <multiselect
            v-model="selectedTags"
            tag-placeholder="Add this as new tag"
            placeholder="Search or add a tag"
            label="name"
            track-by="id"
            :options="suggestedTags"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            @search-change="searchTags($event)"
          ></multiselect>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-9 pa0 right-section">
      <!-- Save -->
      <div class="col-12">
        <pl-button @click.native="saveCategory()" class="pl-primary"
          >SAVE COLLECTION
        </pl-button>
      </div>

      <!-- Premades -->
      <div class="pl6 mt3">
        <draggable
          :list="premades"
          :disabled="!enabled"
          class="list-group"
          ghost-class="ghost"
          @start="dragging = true"
          @end="dragging = false"
        >
          <div
            class="list-group-item col-xs-12 pt3 cursor-move border-b"
            v-for="p in premades"
            :key="p.name"
          >
            <span class="pl-premade-title">{{ p.title }}</span>
            <div class="pb3 pt1">
              <a class="link" @click="gotToRoundtable(p.id)">
                Go to Roundtable
              </a>
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import URLconfigs from 'services/apiConfigs';
  import Multiselect from 'vue-multiselect';
  import draggable from 'vuedraggable';
  //import { orderBy } from 'lodash';

  export default {
    components: { Multiselect, draggable },
    data() {
      return {
        collection: {},
        URLconfigs: URLconfigs,
        nCategories: [],
        fileToUpload: [],
        subjects: [],
        selectedSubjects: [],
        gradeLevels: [],
        selectedGradeLevels: [],
        collectionTags: [],
        suggestedTags: [],
        selectedTags: [],
        enabled: true,
        dragging: false,
        premades: [],
      };
    },
    methods: {
      saveCategory() {
        this.premades.forEach((p, index) => {
          return (p.premades_universe_categories.position = index + 1);
        });
        adminServices
          .editUniverseCategory(this.collectionID, {
            id: this.collectionID,
            description: this.collection.description,
            partner_logo_url: this.collection.partner_logo_url,
            name: this.collection.name,
            position: this.collection.position,
            grade_levels: this.gradeLevels.filter(
              (g) => this.selectedGradeLevels.indexOf(g.id) !== -1
            ),
            subjects: this.selectedSubjects,
            tags: this.selectedTags.map((t) =>
              t.id !== null ? t : { name: t.name }
            ),
            premades: this.premades,
          })
          .then(() => {
            EventBus.$emit('toast-msg', 'Changes saved!');
          })
          .catch(console.error);
      },
      editCategoryName() {
        const new_category_name = prompt('What is the new collection name?');
        if (new_category_name) {
          this.collection.name = new_category_name;
        }
      },
      goToUniverse() {
        window.open(
          `${URLconfigs.universeURL}/collections/${this.collection.id}`,
          '_blank'
        );
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          id: null,
        };
        this.suggestedTags.push(tag);
        this.selectedTags.push(tag);
      },
      gotToRoundtable(premade_id) {
        window.open(
          `${URLconfigs.uiURL}/premade-form/${premade_id}?editing=true`
        );
      },
      searchTags(ev) {
        if (ev === '') {
          this.suggestedTags = this.collection.tags;
        } else {
          adminServices.getTagsByTerm(ev).then((tags) => {
            this.suggestedTags = tags.data;
          });
        }
      },
      loadSubjects() {
        this.$store.dispatch('getAllSubjects').then((results) => {
          this.subjects = results;
        });
      },
      loadGradeLevels() {
        this.$store.dispatch('getAllGrades').then((results) => {
          this.gradeLevels = results;
        });
      },
      loadCollection() {
        adminServices
          .showUniverseCategory(this.collectionID)
          .then((res) => {
            this.collection = res.data;
            this.premades = this.collection.premades;
            this.selectedGradeLevels = this.collection.grade_levels.map(
              (g) => g.id
            );
            this.selectedSubjects = this.collection.subjects;
            this.selectedTags = this.collection.tags;
            this.suggestedTags = this.collection.tags;
          })
          .catch();
      },
      loadCollectionsNumber() {
        this.$store.dispatch('getAllUniverseCategories').then((results) => {
          results.map((c, i) => {
            this.nCategories.push(i);
          });
          this.nCategories.push(results.length);
        });
      },
    },
    computed: {
      collectionID() {
        return this.$route.params.collectionID;
      },
      // Remove all special characters and returns the new file name
      filtered_file_name() {
        const filtered_title = this.category.name.replace(/[^\w\s]/gi, '');
        return `${filtered_title
          .split(' ')
          .join('_')
          .toLowerCase()}_${Date.now().toString()}.webp`;
      },
    },
    mounted() {
      this.loadCollection();
      this.loadCollectionsNumber();
      this.loadSubjects();
      this.loadGradeLevels();
    },
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
  .ma2 .pl-primary.pl-primary {
    font-weight: bold;
    margin-top: 0;
  }

  .mt4 .pl-primary.pl-primary {
    background-color: #fff;
    color: #000;
    font-weight: bold;
    min-width: 320px;
    font-size: 18px;
    min-height: 46px;
    margin: 0 0.55rem 0 2.55rem;
  }

  .pl-display-1 {
    font-weight: 700;
  }

  .section-header {
    color: #323f5f;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 22px;
  }

  .link {
    height: 22px;
    width: 141px;
    color: #7cd2dd;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 22px;
    cursor: pointer;
  }

  .default-position {
    width: 226px;
  }

  .grades {
    display: block;
    .grade {
      float: left;
      margin-right: 1rem;
      label {
        margin: 0;
        color: rgba(60, 60, 60, 0.75);
        font-size: 18px;
        letter-spacing: 0;
        line-height: 25px;
      }
    }
  }

  .right-section {
    display: flex;
    flex-direction: column;
    padding-left: 4rem;
    button {
      float: right;
      font-weight: 700;
    }
  }

  .pl-premade-title {
    font-size: 24px;
    font-weight: 700;
  }

  .collection-name {
    color: #454545;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 39px;
  }

  .ghost {
    opacity: 0.5;
    background: #72ccd7;
  }
</style>

<style lang="scss">
  .admin-edit-collection {
    .multiselect {
      .multiselect__tags {
        border: 2px solid #e1e8ee;
        width: 100%;
        textarea {
          border-radius: 3px;
          border: 1px solid rgba(53, 53, 53, 0.75);
        }
      }
      .multiselect {
        .multiselect__tag {
          background-color: #d8d8d8;
          border-radius: 12px;
          height: 25px;
          color: rgba(41, 41, 41, 0.75);
          font-size: 18px;
          letter-spacing: 0;
          line-height: 25px;
          padding: 0 26px 0 10px;
          i {
            right: 6px;
            top: 6px;
            bottom: 0;
            font-weight: 700;
            font-style: normal;
            width: 14px;
            text-align: center;
            line-height: 6px;
            transition: all 0.2s ease;
            border-radius: 50%;
            height: 14px;
            padding-top: 3px;
            background-color: #787878;
            color: #d8d8d8;
            &::after {
              color: #d8d8d8;
            }
          }
        }

        .multiselect__option--highlight {
          background: #787878;
          &::after {
            background: #787878;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// adminEditCollection.vue?110b37fc